import ModalsInfoLib from '../../lib/modals-info';

export default () => {
    return (
        <div className="modal-info-container">
            <div className="modal-info animate__animated animate__fadeInUp animate__faster">
                <div className="close-button" onClick={e => ModalsInfoLib.close()}>
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M6 18L18 6" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M18 18L6 6" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                </div>

                <div className="modal-info-content">
                    <div className="modal-info-image">
                        <img src={`${window.location.origin}/source/system/modal-info/vip-20-regular-freeplay-info.png`} alt="" />
                    </div>

                    <div className="modal-info-body">
                        <div className="modal-info-body-content">
                            <p>
                                <h1>Regular Freeplay</h1>

                                <span>Receive free bonus funds based on your VIP level.</span>
                                <span>Regular Freeplay becomes available once you meet the required deposit condition.</span>
                                <span>To unlock your next Freeplay, you must deposit <b>the required amount</b> during the cooldown period.</span>
                                <span>You can choose <b>any available game</b> in the casino to use your Freeplay.</span>
                            </p>

                            <p>
                                <h2>Freeplay Amount & Cooldown by VIP Level</h2>
                                <span>
                                    Bronze — <b>$2</b> every 72 hours<br/>
                                    Silver — <b>$3</b> every 48 hours<br/>
                                    Gold — <b>$4</b> every 24 hours<br/>
                                    Platinum — <b>$5</b> every 24 hours<br/>
                                    Diamond — <b>$5</b> every 12–24 hours<br/>
                                    Elite — <b>$5</b> every 12 hours
                                </span>
                            </p>

                            <p>
                                <h2>Is Freeplay withdrawable?</h2>
                                <span>No. Freeplay funds themselves are not withdrawable.</span>
                                <span>However, winnings generated from Freeplay are subject to a <b>1x wagering requirement</b> and must be wagered once before becoming eligible for withdrawal.</span>
                            </p>

                            <p>
                                <h2>What happens if I don’t claim it?</h2>
                                <span>If Freeplay is not claimed within the available period, it expires and will become available again after the next cooldown cycle.</span>
                            </p>
                        </div>
                    </div>
                </div>
            </div>

            <div className="modal-info-overlay animate__animated animate__fadeIn animate__faster"></div>
        </div>
    )
}